// extracted by mini-css-extract-plugin
module.exports = {"wholeThing":"modal_wholeThing__1SVq4","overlay":"modal_overlay__2hheX","modalBody":"modal_modalBody__31bwn","closeButton":"modal_closeButton__1w8bg"};